/*
  Bloc "Code promo" (Hop Cadeau)
  1) bouton "Copier" : copie le code dans le presse-papiers ;
  2) place la carte juste au-dessus du bouton d'aperçu Teeinblue (#teeFormActions), même si Teeinblue
     s'affiche après le chargement de la page ou se redessine (changement de variante, etc.).
*/
(function () {
  'use strict';

  // Script déjà chargé (ex. section rechargée dans l'éditeur de thème) : on replace seulement la carte
  if (window.ohProductPromo) {
    window.ohProductPromo.place();
    return;
  }

  var ACTIONS_ID = 'teeFormActions';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (error) {
        ok = false;
      }
      field.remove();
      if (ok) resolve();
      else reject(new Error('copy failed'));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-oh-promo-copy]') : null;
    if (!button) return;

    var root = button.closest('[data-oh-promo]');
    var codeEl = root && root.querySelector('[data-oh-promo-code]');
    if (!codeEl) return;

    var code = codeEl.textContent.trim();
    var status = root.querySelector('[data-oh-promo-status]');
    var label = button.getAttribute('data-label') || button.textContent;
    var copied = button.getAttribute('data-copied-label') || 'Copié !';

    copyText(code).then(
      function () {
        button.textContent = copied;
        if (status) status.textContent = copied + ' ' + code;
        window.clearTimeout(button.__ohPromoTimer);
        button.__ohPromoTimer = window.setTimeout(function () {
          button.textContent = label;
          if (status) status.textContent = '';
        }, 2000);
      },
      function () {
        // Copie impossible (navigateur ancien) : on sélectionne le code pour un copier-coller manuel
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    );
  });

  // Déplace les cartes [data-move="true"] juste avant les boutons Teeinblue (idempotent)
  function place() {
    var actions = document.getElementById(ACTIONS_ID);
    var cards = document.querySelectorAll('[data-oh-promo][data-move="true"]');

    cards.forEach(function (card) {
      if (actions && actions.parentNode) {
        if (card.nextElementSibling !== actions) {
          actions.parentNode.insertBefore(card, actions);
        }
        card.removeAttribute('data-oh-promo-pending');
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      place();
    };
    // requestAnimationFrame est suspendu dans un onglet en arrière-plan : le setTimeout prend le relais
    window.requestAnimationFrame(run);
    window.setTimeout(function () {
      if (scheduled) run();
    }, 100);
  }

  window.ohProductPromo = { place: place };

  place();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  }
})();
